import { render, staticRenderFns } from "./mails.vue?vue&type=template&id=14443975&scoped=true"
import script from "./mails.vue?vue&type=script&lang=js"
export * from "./mails.vue?vue&type=script&lang=js"
import style0 from "./mails.vue?vue&type=style&index=0&id=14443975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14443975",
  null
  
)

export default component.exports